namespace advisorop.components.advisor {
    
    export class PopNewWorkflowInstanceController {
        // bindings
        workflowMaster: domains.IWorkflowMaster;

        workflowInstance: domains.IWorkflowInstance;

        // bindings inherited from modal
        modalInstance: any; //angular.ui.bootstrap.IModalServiceInstance

        newWorkflowInstanceController: components.common.NewWorkflowInstanceController;

        static $inject = ["$scope"];
        constructor(
            private $scope: ng.IScope
        ) {
        }

        bindNewWorkflowMaster(ctrl: components.common.NewWorkflowInstanceController): void {
            this.newWorkflowInstanceController = ctrl;
            //console.log("New workflow instance component binded...", ctrl);
        };

        workflowInstanceCreated(workflowInstance: domains.IWorkflowInstance): void {
            this.workflowInstance = workflowInstance;
        };
        
        // default modal methods
        save = () => {
            //console.log("PopNewWorkflowInstance save() function fired...");
            //const $resolve = this.$scope.$parent.$resolve;

            const modal = (this.$scope.$parent.$uibModalInstance as angular.ui.bootstrap.IModalServiceInstance);

            this.workflowInstance = this.newWorkflowInstanceController.model;

            modal.close(this.workflowInstance);
        };

        close = () => {
            this.$scope.$parent.$uibModalInstance.dismiss();
        };

        
        // overrides
        $onInit(): void {
            // initialize modal
            const $resolve = this.$scope.$parent.$resolve;

            this.workflowMaster = $resolve.workflowMaster;
        }
    }

    class PopNewWorkflowInstance implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = PopNewWorkflowInstanceController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/pop-new-workflow-instance.html";
        }
        
    }
    angular.module(Constants.APP).component("popNewWorkflowInstance", new PopNewWorkflowInstance());
}
